module.exports = __webpack_public_path__ + "static/media/Illustration_point6.87c5d894.svg";